<template>
  <div class="sig-canvas">
    <div class="sig-canvas__wrapper" ref="wrapper">
      <canvas
        ref="canvas"
        class="sig-canvas__pad"
        @mousedown="startDraw"
        @mousemove="draw"
        @mouseup="stopDraw"
        @mouseleave="stopDraw"
        @touchstart.prevent="startDrawTouch"
        @touchmove.prevent="drawTouch"
        @touchend.prevent="stopDraw"
      />
      <p v-if="!hasStrokes" class="sig-canvas__placeholder">
        Dibuja tu firma aquí
      </p>
    </div>
    <div class="sig-canvas__actions">
      <button class="btn md__btn-third-secondary" @click="clear">
        <i class="el-icon-delete" /> Limpiar
      </button>
      <button class="btn md__btn-primary" :disabled="!hasStrokes" @click="save">
        <i class="el-icon-check" /> Confirmar firma
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignatureCanvas",
  props: {
    width: { type: Number, default: 0 },
    height: { type: Number, default: 200 },
    penColor: { type: String, default: "#31355c" },
    penWidth: { type: Number, default: 2.5 },
    outputFormat: { type: String, default: "image/png" }
  },
  data() {
    return {
      ctx: null,
      drawing: false,
      hasStrokes: false,
      lastX: 0,
      lastY: 0
    };
  },
  methods: {
    initCanvas() {
      const canvas = this.$refs.canvas;
      const wrapper = this.$refs.wrapper;
      const dpr = window.devicePixelRatio || 1;

      const w = this.width || wrapper.clientWidth;
      const h = this.height;

      canvas.width = w * dpr;
      canvas.height = h * dpr;
      canvas.style.width = w + "px";
      canvas.style.height = h + "px";

      this.ctx = canvas.getContext("2d");
      this.ctx.scale(dpr, dpr);
      this.ctx.lineCap = "round";
      this.ctx.lineJoin = "round";
      this.ctx.strokeStyle = this.penColor;
      this.ctx.lineWidth = this.penWidth;
    },

    getPos(e) {
      const rect = this.$refs.canvas.getBoundingClientRect();
      return {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      };
    },

    getTouchPos(e) {
      const touch = e.touches[0];
      const rect = this.$refs.canvas.getBoundingClientRect();
      return {
        x: touch.clientX - rect.left,
        y: touch.clientY - rect.top
      };
    },

    startDraw(e) {
      this.drawing = true;
      const pos = this.getPos(e);
      this.lastX = pos.x;
      this.lastY = pos.y;
      this.ctx.beginPath();
      this.ctx.moveTo(pos.x, pos.y);
    },

    draw(e) {
      if (!this.drawing) return;
      const pos = this.getPos(e);
      this.ctx.lineTo(pos.x, pos.y);
      this.ctx.stroke();
      this.ctx.beginPath();
      this.ctx.moveTo(pos.x, pos.y);
      this.lastX = pos.x;
      this.lastY = pos.y;
      this.hasStrokes = true;
    },

    startDrawTouch(e) {
      this.drawing = true;
      const pos = this.getTouchPos(e);
      this.lastX = pos.x;
      this.lastY = pos.y;
      this.ctx.beginPath();
      this.ctx.moveTo(pos.x, pos.y);
    },

    drawTouch(e) {
      if (!this.drawing) return;
      const pos = this.getTouchPos(e);
      this.ctx.lineTo(pos.x, pos.y);
      this.ctx.stroke();
      this.ctx.beginPath();
      this.ctx.moveTo(pos.x, pos.y);
      this.lastX = pos.x;
      this.lastY = pos.y;
      this.hasStrokes = true;
    },

    stopDraw() {
      if (this.drawing) {
        this.drawing = false;
        this.ctx.beginPath();
      }
    },

    clear() {
      const canvas = this.$refs.canvas;
      this.ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.hasStrokes = false;
      this.$emit("clear");
    },

    save() {
      if (!this.hasStrokes) return;
      const dataUrl = this.$refs.canvas.toDataURL(this.outputFormat);
      this.$emit("save", dataUrl);
    },

    getDataUrl() {
      return this.$refs.canvas.toDataURL(this.outputFormat);
    },

    isEmpty() {
      return !this.hasStrokes;
    }
  },
  mounted() {
    this.initCanvas();
    window.addEventListener("resize", this.initCanvas);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.initCanvas);
  }
};
</script>

<style lang="scss" scoped>
.sig-canvas {
  &__wrapper {
    position: relative;
    border: 1.5px dashed #e4eaf6;
    border-radius: 12px;
    background: #fafbfd;
    overflow: hidden;
  }
  &__pad {
    display: block;
    cursor: crosshair;
    touch-action: none;
  }
  &__placeholder {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #989aae;
    font-size: 14px;
    pointer-events: none;
    margin: 0;
    user-select: none;
  }
  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 12px;
  }
}
</style>
